import { Banner } from '@sunwebgroup/uds-ui/banner'
import { Benefits } from '@sunwebgroup/uds-ui/benefits'
import { Skeleton } from '@sunwebgroup/uds-ui/skeleton'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import { useIntl } from '@/intl'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'
import { useBookingDetailsStore } from '../../infrastructure/useBookingDetailsStore'
import { renderExternalLink } from '../utils/renderExternalLink'
import { BookingDetailsSection } from './BookingDetailsSection'
import { ExcursionCard } from './ExcursionCard'
import styles from './ExcursionsSection.module.css'
import { IconRow } from './IconRow'

export function ExcursionsSection() {
  const { formatMessage } = useIntl()
  const { items: excursions, loadStatus, allExcursionsLink } = useBookingDetailsStore(state => state.excursions)
  const conditionsUrl = useConfiguration('links.conditions')

  if (loadStatus === 'idle') {
    return null
  }

  const renderContent = () => {
    if (loadStatus === 'loading') {
      return (
        <div className={styles.grid}>
          {[0, 1, 2].map(i => (
            <Skeleton key={i} className={styles.skeletonCard} />
          ))}
        </div>
      )
    }

    if (loadStatus === 'error') {
      return (
        <Banner color="danger" size="M" hasIcon contentIsCentered>
          <Banner.Text>{formatMessage({ id: 'booking_details_excursions_error_text' })}</Banner.Text>
        </Banner>
      )
    }

    if (excursions.length === 0) {
      return (
        <Banner color="informative" size="M" hasIcon contentIsCentered>
          <Banner.Text>{formatMessage({ id: 'booking_details_excursions_empty_text' })}</Banner.Text>
        </Banner>
      )
    }

    return (
      <>
        <div className={styles.grid}>
          {excursions.map(excursion => (
            <ExcursionCard key={excursion.url} excursion={excursion} />
          ))}
        </div>
        {allExcursionsLink && (
          <Typography as="a" href={allExcursionsLink} target="_blank" rel="noreferrer noopener" className={styles.viewMoreLink}>
            {formatMessage({ id: 'booking_details_excursions_view_more' })}
          </Typography>
        )}
        <div className={styles.disclaimer}>
          <IconRow
            glyph="InformationInCircle"
            description={formatMessage(
              { id: 'booking_details_excursions_disclaimer' },
              { link: renderExternalLink(conditionsUrl) },
            )}
          />
        </div>
      </>
    )
  }

  return (
    <BookingDetailsSection
      iconName="Mountains"
      title={formatMessage({ id: 'booking_details_excursions_title' })}
      description={formatMessage({ id: 'booking_details_excursions_description' })}
    >
      <Benefits.Root display="list" className={styles.highlights}>
        <Benefits.Item icon="CheckMarkSmall" title={formatMessage({ id: 'booking_details_excursions_highlight_exclusive_offer' })} />
        <Benefits.Item icon="CheckMarkSmall" title={formatMessage({ id: 'booking_details_excursions_highlight_pickup_service' })} />
        <Benefits.Item icon="CheckMarkSmall" title={formatMessage({ id: 'booking_details_excursions_highlight_secure_spot' })} />
      </Benefits.Root>
      {renderContent()}
    </BookingDetailsSection>
  )
}
